import Component from '@glimmer/component';
import {
  HdsSideNavPortal,
  HdsAppSideNavPortal,
} from '@hashicorp/design-system-components/components';
import { variation } from 'ember-launch-darkly';

import type { HdsSideNavPortalSignature } from '@hashicorp/design-system-components/components/hds/side-nav/portal/index';

interface LayoutSidebarSubnavSignature {
  Blocks: HdsSideNavPortalSignature['Blocks'];
  Element: HdsSideNavPortalSignature['Element'];
}

export default class LayoutSidebarSubnav extends Component<LayoutSidebarSubnavSignature> {
  <template>
    {{! TODO:  https://hashicorp.atlassian.net/browse/FE-76 Remove feature flag }}
    {{#if (variation "hcp-ui-enterprise-nav")}}
      <HdsAppSideNavPortal
        @targetName="hds-side-nav-portal-target"
        @ariaLabel="Secondary"
        ...attributes
        data-test-sidebar-subnav-content
        as |Subnav|
      >
        {{yield Subnav}}
      </HdsAppSideNavPortal>
    {{else}}
      <HdsSideNavPortal
        @ariaLabel="Secondary"
        ...attributes
        data-test-sidebar-subnav-content
        as |Subnav|
      >
        {{yield Subnav}}
      </HdsSideNavPortal>
    {{/if}}
  </template>
}
